module.exports = __webpack_public_path__ + "static/people_img16-823a6fc08bf4b3915ace13493f7854e2.png";